import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../../_globals';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-details-form-dialog',
  templateUrl: './product-details-form.component.html',
})
export class ProductDetailsFormComponent implements OnInit {
  @Input() product: any;

  constructor(public globals: Globals, public router: Router) {}

  ngOnInit() {
    console.log('product details', this.product);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/products/product-details-form/product-details-form.component.ts